module.exports = __webpack_public_path__ + "static/image/sign/kimbongjin@2x.png?b01c3d7e";